import React from "react";
import { Modal, Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function ViewCryptocurrency({ show, onHide, viewData }) {
    const { t } = useTranslation();
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{t('view_cryptocurrency')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {viewData && (
                    <>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('select_network')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.symbol}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('coin_name')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.coin_name}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('logo_url')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                <img src={viewData.logo_url} alt="Logo" style={{ width: '50px', height: '50px' }} />
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('coin_symbol')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.symbol}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('contract_address')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.contract_address}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('decimal_places')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.decimal_places}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('is_token')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.is_token}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('wallet_type')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.wallet_type}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('usd_price')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.usd_price}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('etoken_min_withdrawal_amount')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.etoken_min_withdrawal_amount}
                            </div>
                        </div>
                        {(viewData.coin_symbol === "USDT" || viewData.coin_symbol === "USDC" || viewData.symbol === "USDT" || viewData.symbol === "USDC") && (
                            <div className="row mb-2 border-bottom pb-1">
                                <div className="col-4 fw-bold text-capitalize">
                                    {t('allow_for_swap_staking') || "Allow For Swap Staking"}
                                </div>
                                <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                    {viewData.allow_for_swap_staking || "no"}
                                </div>
                            </div>
                        )}
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('is_swapable')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.is_swapable}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('swap_fee_cryptocurrency')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.swap_fee_coin_name}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('swap_fee_type')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.swap_fee_type}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('swap_fee_amount')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.swap_fee_amount}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('transfer_fee_status')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.transfer_fee_status}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('transfer_fee_cryptocurrency')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.transfer_fee_coin_name}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('transfer_fee_type')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.transfer_fee_type}
                            </div>
                        </div>
                        <div className="row mb-2 border-bottom pb-1">
                            <div className="col-4 fw-bold text-capitalize">
                                {t('transfer_fee_amount')}
                            </div>
                            <div className="col-8" style={{ wordBreak: 'break-word' }}>
                                {viewData.transfer_fee_amount}
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewCryptocurrency;
